// removed by extract-text-webpack-plugin
module.exports = {"designs":"designs_2-iA7","book":"book_30Stk","active":"active_3hSA8","thumbnail":"thumbnail_37An4","label":"label_2Ydfd"};


//////////////////
// WEBPACK FOOTER
// ./app/components/reset-password/styles.scss
// module id = 498
// module chunks = 1